import Query from "./query";
import GetVolumePosition from "./getVolumePosition";
import GetModelPosition from "./getModelPosition";

class GetPosition extends Query {
    bodyType;

    constructor() {
        super("getPosition");
        this.childQuery = [
            GetModelPosition,
            GetVolumePosition,
        ];
        this.childQuery = this.childQuery.map(query => new query());
    }

    async execute(params, options) {
        const selectedBody = params[1];
        this.bodyType = params[0];
        const query = this.getChildQuery(this.bodyType);
        if (query) {
            return query.executeChildQuery(selectedBody, options);
        } else {
            console.error("Body type not found. Name: " + this.bodyType);
        }

    }

    getChildQuery(queryName) {
        return this.childQuery.find(query => query.name === queryName);
    }
}

export default GetPosition;